import ApiService from '../../services/ApiService';
import { CashTransaction } from './types';

class CashPayment extends CashTransaction {
  constructor(tx: CashTransaction) {
    super();
    Object.assign(this, tx);
  }

  doFullRefund({ userInitials, sessionId }: { userInitials: string, sessionId: string }) {
    return ApiService.put(`/payment/cash/${this.id}/refund`, { amount: this.amount, full: true, userInitials, sessionId });
  }
}

export default CashPayment;
